import { FormikFormValues } from "../../../../pages/operations/pickup-request-sheet/CreatePickupRequestSheet";
import { PickupRequestSheetListSearch } from "../../../../types/operations/pickupRequestSheetInterface";
import api from "../../../../lib/api";


export const getPickupRequestSheetListApi = async (data: PickupRequestSheetListSearch) => {
  return await api.get(`operations/pickup-sheet/${data.page}/${data.pageLimit}`, {
    params: {
      // search: data?.search ?? ""
      status: data?.pickupStatus,
      type: data?.pickupType
    }
  });
};

export const createPickupRequestSheetApi = async (data: FormikFormValues) => {
  return await api.post(`operations/pickup-sheet`, data);
};

export const editPickupRequestSheetByIdApi = async (data: {values: FormikFormValues, prsId: string}) => {
  return await api.put(`operations/pickup-sheet/${data.prsId}`, data.values);
};

export const getPickupRequestSheetByIdApi = async (id: string) => {
  return await api.get(`operations/pickup-sheet/${id}`);
};